export default __webpack_public_path__ + "static/media/icono-prod-equipo-lhd.56d6e424.png";